"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var colors = _tokens.default.colors,
    spacing = _tokens.default.spacing;

var IconThumbsDownFilled = function IconThumbsDownFilled(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var sizeArray = Object.entries(spacing.icons);
  var colorArray = Object.entries(colors.icons);
  var sizeOptions = new Map(sizeArray);
  var displaySize = sizeOptions.get(props.size);
  var colorOptions = new Map(colorArray);
  var displayColor = colorOptions.get(props.color);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: props.color && displayColor,
    "aria-hidden": !title,
    role: title ? "img" : null,
    width: props.size && displaySize,
    height: props.size && displaySize,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 00-1 1v8a1 1 0 102 0V1a1 1 0 00-1-1zm3 1.462c0-.45.13-.805.388-1.068C4.647.13 4.978 0 5.383 0h6.625c.502.062.877.156 1.126.282.614.311.836.51 1.108.817.273.307.536.734.71 1.321.055.187.092.45.112.79l.91 4.508c.035.36.035.634 0 .823a4.478 4.478 0 01-.359 1.016c-.308.583-.665.885-.967 1.119-.293.228-.871.517-1.514.619-.342.054-.929.054-1.76 0v1.592a4.668 4.668 0 01-.066.481c-.051.24-.126.449-.19.613a3.283 3.283 0 01-.7 1.078c-.202.196-.653.56-1.058.723A3.535 3.535 0 018.148 16a1.5 1.5 0 01-.467-.086c-.224-.081-.458-.23-.566-.375a3.985 3.985 0 01-.368-.635L4.101 9.479a1.957 1.957 0 01-.078-.269A1.7 1.7 0 014 8.944V1.462z"
  }));
};

IconThumbsDownFilled.propTypes = {
  title: _propTypes.default.string,
  titleId: _propTypes.default.string,
  size: _propTypes.default.oneOf(["sm", "md"]),
  color: _propTypes.default.oneOf(["primaryBlue", "secondaryBlue", "darkGrey", "white"])
};
IconThumbsDownFilled.defaultProps = {
  size: "sm",
  color: "darkGrey",
  focusable: !1
};
var _default = IconThumbsDownFilled;
exports.default = _default;